import React, {Suspense} from 'react';
import { lazily } from 'react-lazily';
import Alert from '../Alert';
import { PageLoading } from '../Loading';
const { BarChart, PieChart } = lazily(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */'./TheCharts'));

const Chart = (props) => {
    if (props.type === 'Bar') {
        return <Suspense fallback={<PageLoading />}>
            <BarChart {...props} />
        </Suspense>;
    } else if (props.type === 'Pie') {
        return <Suspense fallback={<PageLoading />}>
            <PieChart {...props} />
        </Suspense>;
    } else {
        return <Alert theme="error" title={`Unknown chart tpe ${props.type}`} message="Try harder" />;
    }
}

// https://nagix.github.io/chartjs-plugin-colorschemes/colorchart.html
// https://github.com/nagix/chartjs-plugin-colorschemes/blob/master/src/colorschemes/colorschemes.brewer.js

// brewer.Paired12
// const brewerPaired12 = ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928'];

const tableau10 = ['#4E79A7', '#F28E2B', '#E15759', '#76B7B2', '#59A14F', '#EDC948', '#B07AA1', '#FF9DA7', '#9C755F', '#BAB0AC'];
const tableau20 = ['#4E79A7', '#A0CBE8', '#F28E2B', '#FFBE7D', '#59A14F', '#8CD17D', '#B6992D', '#F1CE63', '#499894', '#86BCB6', '#E15759', '#FF9D9A', '#79706E', '#BAB0AC', '#D37295', '#FABFD2', '#B07AA1', '#D4A6C8', '#9D7660', '#D7B5A6'];

// const blue20      = ['#b9ddf1', '#afd6ed', '#a5cfe9', '#9bc7e4', '#92c0df', '#89b8da', '#80b0d5', '#79aacf', '#72a3c9', '#6a9bc3', '#6394be', '#5b8cb8', '#5485b2', '#4e7fac', '#4878a6', '#437a9f', '#3d6a98', '#376491', '#305d8a', '#2a5783'];
// const orange20    = ['#ffc685', '#fcbe75', '#f9b665', '#f7ae54', '#f5a645', '#f59c3c', '#f49234', '#f2882d', '#f07e27', '#ee7422', '#e96b20', '#e36420', '#db5e20', '#d25921', '#ca5422', '#c14f22', '#b84b23', '#af4623', '#a64122', '#9e3d22'];
// const green20     = ['#b3e0a6', '#a5db96', '#98d687', '#8ed07f', '#85ca77', '#7dc370', '#75bc69', '#6eb663', '#67af5c', '#61a956', '#59a253', '#519c51', '#49964f', '#428f4d', '#398949', '#308344', '#2b7c40', '#27763d', '#256f3d', '#24693d'];
// const red20       = ['#ffbeb2', '#feb4a6', '#fdab9b', '#fca290', '#fb9984', '#fa8f79', '#f9856e', '#f77b66', '#f5715d', '#f36754', '#f05c4d', '#ec5049', '#e74545', '#e13b42', '#da323f', '#d3293d', '#ca223c', '#c11a3b', '#b8163a', '#ae123a'];
// const purple20    = ['#eec9e5', '#eac1df', '#e6b9d9', '#e0b2d2', '#daabcb', '#d5a4c4', '#cf9dbe', '#ca96b8', '#c48fb2', '#be89ac', '#b882a6', '#b27ba1', '#aa759d', '#a27099', '#9a6a96', '#926591', '#8c5f86', '#865986', '#81537f', '#7c4d79'];
// const brown20     = ['#eedbbd', '#ecd2ad', '#ebc994', '#eac085', '#e8b777', '#e5ae6c', '#e2a562', '#de9d5a', '#d99455', '#d38c54', '#ce8451', '#c9784d', '#c47247', '#c16941', '#bd6036', '#b85636', '#b34d34', '#ad4433', '#a63d32', '#9f3632'];
// const gray20      = ['#d5d5d5', '#cdcecd', '#c5c7c6', '#bcbfbe', '#b4b7b7', '#acb0b1', '#a4a9ab', '#9ca3a4', '#939c9e', '#8b9598', '#848e93', '#7c878d', '#758087', '#6e7a81', '#67737c', '#616c77', '#5b6570', '#555f6a', '#4f5864', '#49525e'];
// const grayWarm20  = ['#dcd4d0', '#d4ccc8', '#cdc4c0', '#c5bdb9', '#beb6b2', '#b7afab', '#b0a7a4', '#a9a09d', '#a29996', '#9b938f', '#948c88', '#8d8481', '#867e7b', '#807774', '#79706e', '#736967', '#6c6260', '#665c51', '#5f5654', '#59504e'];
// const blueTeal20  = ['#bce4d8', '#aedcd5', '#a1d5d2', '#95cecf', '#89c8cc', '#7ec1ca', '#72bac6', '#66b2c2', '#59acbe', '#4ba5ba', '#419eb6', '#3b96b2', '#358ead', '#3586a7', '#347ea1', '#32779b', '#316f96', '#2f6790', '#2d608a', '#2c5985'];
// const orangeGld20 = ['#f4d166', '#f6c760', '#f8bc58', '#f8b252', '#f7a84a', '#f69e41', '#f49538', '#f38b2f', '#f28026', '#f0751e', '#eb6c1c', '#e4641e', '#de5d1f', '#d75521', '#cf4f22', '#c64a22', '#bc4623', '#b24223', '#a83e24', '#9e3a26'];
// const greenGold20 = ['#f4d166', '#e3cd62', '#d3c95f', '#c3c55d', '#b2c25b', '#a3bd5a', '#93b958', '#84b457', '#76af56', '#67a956', '#5aa355', '#4f9e53', '#479751', '#40914f', '#3a8a4d', '#34844a', '#2d7d45', '#257740', '#1c713b', '#146c36'];


const smallMerged20s = [
    '#b9ddf1', '#ffc685', '#b3e0a6', '#ffbeb2', '#eec9e5', '#eedbbd', '#d5d5d5', '#dcd4d0', '#bce4d8', '#f4d166',
    '#2a5783', '#9e3d22', '#24693d', '#ae123a', '#7c4d79', '#9f3632', '#49525e', '#59504e', '#2c5985', '#9e3a26', '#146c36',
    // '#a5cfe9', '#f9b665', '#98d687', '#fdab9b', '#e6b9d9', '#ebc994', '#c5c7c6', '#cdc4c0', '#a1d5d2', '#f8bc58', '#d3c95f',
    // '#376491', '#af4623', '#27763d', '#c11a3b', '#865986', '#ad4433', '#555f6a', '#665c51', '#2f6790', '#b24223', '#257740',
    '#92c0df', '#f5a645', '#85ca77', '#fb9984', '#daabcb', '#e8b777', '#b4b7b7', '#beb6b2', '#89c8cc', '#f7a84a', '#b2c25b',
    '#437a9f', '#c14f22', '#308344', '#d3293d', '#926591', '#b85636', '#616c77', '#736967', '#32779b', '#c64a22', '#34844a',
    // '#80b0d5', '#f49234', '#75bc69', '#f9856e', '#cf9dbe', '#e2a562', '#a4a9ab', '#b0a7a4', '#72bac6', '#f49538', '#93b958',
    // '#4e7fac', '#d25921', '#428f4d', '#e13b42', '#a27099', '#c16941', '#6e7a81', '#807774', '#3586a7', '#d75521', '#40914f',
    '#72a3c9', '#f07e27', '#67af5c', '#f5715d', '#c48fb2', '#d99455', '#939c9e', '#a29996', '#59acbe', '#f28026', '#76af56',
    '#5b8cb8', '#e36420', '#519c51', '#ec5049', '#b27ba1', '#c9784d', '#7c878d', '#8d8481', '#3b96b2', '#e4641e', '#4f9e53',
];

const bigMerged20s = [
    '#b9ddf1', '#ffc685', '#b3e0a6', '#ffbeb2', '#eec9e5', '#eedbbd', '#d5d5d5', '#dcd4d0', '#bce4d8', '#f4d166',
    '#2a5783', '#9e3d22', '#24693d', '#ae123a', '#7c4d79', '#9f3632', '#49525e', '#59504e', '#2c5985', '#9e3a26', '#146c36',
    '#a5cfe9', '#f9b665', '#98d687', '#fdab9b', '#e6b9d9', '#ebc994', '#c5c7c6', '#cdc4c0', '#a1d5d2', '#f8bc58', '#d3c95f',
    '#376491', '#af4623', '#27763d', '#c11a3b', '#865986', '#ad4433', '#555f6a', '#665c51', '#2f6790', '#b24223', '#257740',
    '#92c0df', '#f5a645', '#85ca77', '#fb9984', '#daabcb', '#e8b777', '#b4b7b7', '#beb6b2', '#89c8cc', '#f7a84a', '#b2c25b',
    '#437a9f', '#c14f22', '#308344', '#d3293d', '#926591', '#b85636', '#616c77', '#736967', '#32779b', '#c64a22', '#34844a',
    '#80b0d5', '#f49234', '#75bc69', '#f9856e', '#cf9dbe', '#e2a562', '#a4a9ab', '#b0a7a4', '#72bac6', '#f49538', '#93b958',
    '#4e7fac', '#d25921', '#428f4d', '#e13b42', '#a27099', '#c16941', '#6e7a81', '#807774', '#3586a7', '#d75521', '#40914f',
    '#72a3c9', '#f07e27', '#67af5c', '#f5715d', '#c48fb2', '#d99455', '#939c9e', '#a29996', '#59acbe', '#f28026', '#76af56',
    '#5b8cb8', '#e36420', '#519c51', '#ec5049', '#b27ba1', '#c9784d', '#7c878d', '#8d8481', '#3b96b2', '#e4641e', '#4f9e53',
];

const pickColour = (index, count) => {
    if (count <= 10) {
        return tableau10[index];
    }

    if (count <= 20) {
        return tableau20[index];
    }

    if (count <= smallMerged20s.length) {
        return smallMerged20s[index];
    }

    return bigMerged20s[index];
}

export {
    pickColour,
}

export default Chart;
